import React, { useEffect } from 'react';

const BASE_URL = 'https://www.laizyleads.de';

/**
 * Lightweight SEO helper without Helmet (avoids invariant errors).
 * Updates document.title and head meta tags on the client.
 */
export default function SEO({ title, description, path = '/', keywords, image }) {
  const url = `${BASE_URL}${path}`;
  const ogImage = image || `${BASE_URL}/logo.png`;

  useEffect(() => {
    if (title) document.title = title;
    const tags = [
      { name: 'description', content: description },
      { name: 'keywords', content: keywords },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: url },
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
      { property: 'og:image', content: ogImage },
      { property: 'og:locale', content: 'de_DE' },
      { property: 'og:site_name', content: 'LaizyLeads' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: title },
      { name: 'twitter:description', content: description },
      { name: 'twitter:image', content: ogImage },
    ];

    tags.forEach(({ name, property, content }) => {
      if (!content) return;
      const selector = name ? `meta[name="${name}"]` : `meta[property="${property}"]`;
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement('meta');
        if (name) el.setAttribute('name', name);
        if (property) el.setAttribute('property', property);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    });

    // canonical link
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', url);
  }, [title, description, url, keywords, ogImage]);

  return null;
}
